import React, { useContext, useState } from 'react'
import Button from '@mui/material/Button'
import ButtonGroup from '@mui/material/ButtonGroup'
import Stack from '@mui/material/Stack'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { ActionPanelItem } from './EmployeeApplicationActionPanel'
import BigModal from '../../../components/Modals/BigModal'
import API from '../../../services/API'
import { GlobalContext } from '../../../App'

// Extends (or re-extends after a decline) an offer of employment. The
// applicant is emailed and can accept/decline from their application
// tracker; accepting moves the pipeline to "Offer Accepted".
const ExtendOffer = ({ application, getApplication }) => {
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState('')
  const [sending, setSending] = useState(false)
  const { setToast } = useContext(GlobalContext)

  const reExtending = !!application.offerRejected
  const disabled =
    application.state !== 'Submitted' ||
    (!!application.offerExtended && !application.offerRejected)

  const handleExtend = () => {
    setSending(true)
    API.post('/extend-employment-offer', {
      applicationID: application._id,
      message,
    })
      .then((res) => {
        if (res.status === 200) {
          setToast({ message: 'Offer Extended' })
          setOpen(false)
          getApplication()
        } else {
          setToast({
            message: res?.data?.error ?? 'Unable to extend offer',
            severity: 'error',
          })
        }
      })
      .finally(() => setSending(false))
  }

  return (
    <ActionPanelItem>
      <Button
        variant="outlined"
        color="anPurple"
        fullWidth
        size="small"
        onClick={() => setOpen(true)}
        disabled={disabled}
      >
        {reExtending ? 'Re-extend Offer' : 'Extend Offer'}
      </Button>
      <BigModal autoWidth open={open} onClose={() => setOpen(false)}>
        <Stack gap={1} alignItems="center">
          <Typography variant="title3">
            Extend an offer of employment?
          </Typography>
          <Typography variant="caption">
            The applicant will be emailed and asked to accept or decline the
            offer from their application tracker.
          </Typography>
          <TextField
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            fullWidth
            minRows={2}
            multiline
            placeholder="Optional message to include in the offer email"
          />
          <ButtonGroup>
            <Button
              variant="outlined"
              color="error"
              onClick={() => setOpen(false)}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="success"
              onClick={handleExtend}
              disabled={sending}
            >
              Extend Offer
            </Button>
          </ButtonGroup>
        </Stack>
      </BigModal>
    </ActionPanelItem>
  )
}

export default ExtendOffer
